<template>
    <div class="landing-offer">
        <div class="title"><b>Offre conversion fioul<br/>Bénéficiez en + des aides Antargaz<br/></b>jusqu'à</div>
        <div class="number">2 172<sup>€<sup>(1)</sup></sup></div>
        <div class="subtitle"> de primes avec Antargaz</div>
    </div>
</template>

<script>
    export default {
        name: 'LandingOffer',
        props: {
            image: { type: String }
        }
    }
</script>

<style scoped lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import settings
    @import LandingOffer
</style>
